<template>
    <div class="main-grids">
        <div class="recommended">
            <layoutLiveWatch :liveData="liveData" :routePath="liveRoutePath" :embedCode="embedCode"></layoutLiveWatch>
        </div>
    </div>
</template>

<script>
import layoutLiveWatch from '@/components/LiveWatch'

export default {
  name: '',
  data () {
    return {
      liveData: [],
      embedCode: '',
      liveRoutePath: window.location.href
    }
  },
  props: ['meta'],
  components: {
    layoutLiveWatch
  },
  mounted () {
    this.getLive()
  },
  methods: {
    getLive () {
      let self = this
      this.$http.get('/getLiveContent/' + self.$route.params.lid)
        .then(function (response) {
          if (response.data.length !== 0) {
            self.liveData = response.data
            // cmsusr  cmsrefdom
            if (self.$store.state.userInfo.user_account) {
              self.liveData.player = self.liveData.player + '?cuac=' + self.$store.state.userInfo.user_account + '&token=' + self.$store.state.token.replace('Bearer ', '')
            }
            self.embedCode = '<iframe src="' + self.liveData.player + '" allowfullscreen></iframe>'
          } else {
            self.$router.push({ name: 'Home' })
          }
        })
    }
  },
  metaInfo () {
    return {
      titleTemplate: this.liveData.title + ' - %s'
    }
  }
}
</script>
